import config from 'ember-get-config';

export async function initialize() {
  if (typeof FastBoot !== 'undefined' || config.environment !== 'development') {
    return;
  }

  // Dynamically import metadata only in development
  // This ensures metadata doesn't bloat production bundles
  const module = await import('../utils/spds/metadata/loader');
  window.SPDS_METADATA = module.ALL_METADATA;
}

export default {
  initialize,
};
